module.exports = __webpack_public_path__ + "static/09_tatiana_ohara-9d053b2c00854e83ee9c09242c562075.jpg";